import request from '@/utils/request'

const chechangPermission = {
  list(query) {
    return request({
      url: '/chechang/permission/list',
      method: 'get',
      params: query
    })
  },
  adminSelect(query) {
    return request({
      url: '/chechang/permission/adminSelect',
      method: 'get',
      params: query
    })
  },
  detail(query) {
    return request({
      url: '/chechang/permission/detail',
      method: 'get',
      params: query
    })
  },
  save(data) {
    return request({
      url: '/chechang/permission/save',
      method: 'post',
      data
    })
  },
  remove(data) {
    return request({
      url: '/chechang/permission/remove',
      method: 'post',
      data
    })
  }
}

export default chechangPermission
